import React from 'react';
import CloseIcon from 'components/icon/close-icon';
import styles from './style.module.scss';

interface Props {
  /** Custom content to render inside the banner */
  children: React.ReactNode;
  /** Callback when user dismisses the banner */
  onDismiss?: () => void;
}

/**
 * SearchSuggestionsBanner Component
 * 
 */
export default function SearchSuggestionsBanner({
  children,
  onDismiss,
}: Props) {
  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div className={styles.component}>
      {children}
      {onDismiss && (
        <button
          className={styles.closeButton}
          onClick={handleDismiss}
          aria-label="Close banner"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
}
